import React, { useRef, useState } from "react";
import { LoginRegister } from "../LoginRegister";
import { Row } from "reactstrap";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { ForgotPasswordSecond } from "./ForgotPasswordSecond";
import { disRememberApi } from "../../../api";
import { useTranslation } from "react-i18next";
import { Alert, ModalComp } from "../../../shared";
const ForgotPassword = () => {
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const { t } = useTranslation();
  const [next, setNext] = useState(false);
  const form = useRef(null);
  const initialLoginValues = {
    email: "",
  };

  const submitLoginForm = () => {
    const data = new FormData(form.current);
    disRememberApi(data)
    .then(() => {
      setNext(!next);
    })
    .catch(() => {
      setShowAlert((prevState) => ({
        ...prevState,
        show: true,
        message: t("کاربری با این ایمیل یافت نشد!"),
        type: "Error",
      }));
      setTimeout(() => {
        setShowAlert((prevState) => ({
          ...prevState,
          show: false,
        }));
      }, 5000);
    });
  };

  const validationSchemaLogin = Yup.object({
    email: Yup.string()
      .required(t("ایمیل را وارد کنید"))
      .email(t("ایمیل را طبق فرمت وارد کنید")),
  });

  return (
    <LoginRegister>
      <div className="px-4 pt-5">
        {!next ? (
          <>
            <Row className="justify-content-center flex-column mb-5">
              <h6>{t("رمز عبور خود را فراموش کردید؟")}</h6>
              <p className="fn12">
                {t(
                  "لطفا ایمیل خود را در زیر وارد کنید تا دستورالعمل های تنظیم مجدد رمز عبور خود را دریافت کنید"
                )}
              </p>
            </Row>
            <Row className="justify-content-center flex-column">
              <Formik
                initialValues={initialLoginValues}
                onSubmit={submitLoginForm}
                validationSchema={validationSchemaLogin}
              >
                {(props) => (
                  <Form ref={form}>
                    <div className="mb-3">
                      <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                        {props.values.email && (
                          <p className="fn12 m-0">{t("ایمیل")}</p>
                        )}
                        <input
                          type="email"
                          placeholder={t("ایمیل")}
                          name="email"
                          className="w-100 fn12"
                          onChange={props.handleChange}
                          onBlur={props.handleBlur}
                        />
                      </div>
                      <ErrorMessage name="email">
                        {(errMsg) => (
                          <div className="text-danger fn10 mt-1">{errMsg}</div>
                        )}
                      </ErrorMessage>
                    </div>
                    <button className="btn btn-primary formBtn mt-4">
                      {t("ادامه")}
                    </button>
                  </Form>
                )}
              </Formik>
            </Row>
          </>
        ) : (
          <ForgotPasswordSecond />
        )}
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </LoginRegister>
  );
};

export { ForgotPassword };
